<h2 matDialogTitle *ngIf="showDialogHeadline">Aufmaß</h2>
<!--<mat-dialog-content>-->
<div *ngFor="let item of this._quantityHistoryForm?.controls; let i = index" class="flex gap-4 flex-wrap items-center">
    <button mat-icon-button (click)="remove(i)" color="warn"><fa-icon icon="trash"></fa-icon></button>
    <mat-form-field>
        <mat-label>Datum</mat-label>
        <input [formControl]="item.controls.date" matInput (click)="picker.open()" [matDatepicker]="picker" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Menge</mat-label>
<!--        <input type="number" [formControl]="item.controls.quantityDelta" matInput />-->
        <app-calculation-input
            [maxDecimalPlaces]="AccountsReceivableLedgerEntity.QuantityHistoryDeltaDecimalPlaces"
            [formula]="item.controls.quantityDeltaFormula.value"
            (formulaChange)="item.controls.quantityDeltaFormula.setValue($event); item.controls.quantityDeltaFormula.markAsDirty()"
            [formControl]="item.controls.quantityDelta"
        ></app-calculation-input>

    </mat-form-field>
</div>
<div class="flex gap-4 flex-wrap items-center justify-between p-2">
    <button mat-raised-button (click)="add()">+ Aufmaß hinzufügen</button>
    <span class="font-bold">Summe: {{quantity$ | async | number}}</span>
</div>
<!--</mat-dialog-content>-->
<mat-dialog-actions *ngIf="showDialogActions">
    <button app-button mat-dialog-close="" Inverted Color="cancel">schließen</button>
</mat-dialog-actions>
